module.exports = __webpack_public_path__ + "static/media/arrow-purple.169deb1a.svg";